import { DraftListItemSkeleton } from './DraftListItemSkeleton';

/** Enough rows to fill the list pane on a laptop screen. */
const ROWS = 6;

/** The queue while it loads: enough rows to fill the eye, none of them clickable. */
export const DraftListSkeleton = () => (
  <>
    {Array.from({ length: ROWS }, (_, index) => (
      <DraftListItemSkeleton key={index} />
    ))}
  </>
);
